import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export const Marquee = ({ text }) => {
  return (
    <div className="relative w-full overflow-hidden bg-[#7dd3fc] py-6">
      <motion.div
        className="flex whitespace-nowrap"
        animate={{
          x: [0, -1920]
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 25,
            ease: "linear",
          },
        }}
      >
        {[...Array(4)].map((_, i) => (
          <span
            key={i}
            className="text-[#0a1628] text-3xl md:text-4xl font-bold tracking-wider mx-8"
          >
            {text}
          </span>
        ))}
      </motion.div>
    </div>
  );
};
